import * as yup from "yup"

export const formValidationSchema = yup
  .object()
  .shape({
    service_id: yup.number().required("Wajib Dipilih").min(1, "Wajib Dipilih"),
    user_batch_request: yup.number().required("Wajib Dipilih").min(1, "Wajib Dipilih"),
    user_fullname: yup
      .string()
      .trim()
      .min(3, "Minimal 3 karakter")
      .max(50, "Maksimal 50 karakter")
      .matches(/^(?! )[A-Za-z\s]*$/, "Hanya boleh huruf dan spasi"),
    user_email: yup.string().required("Wajib Diisi"),
    user_phone_number: yup
      .string()
      .required("Wajib Diisi")
      .min(8, "Minimal 8 karakter")
      .max(13, "Maksimal 13 karakter")
      .matches(/^(?!([0-9])\1+$)[1-9][0-9]*$/, "Format yang kamu masukkan salah")
      .test(
        "not-start-with-62-or-0",
        "Format yang kamu masukkan salah",
        (value) => value && !value.startsWith("0") && !value.startsWith("62")
      ),
    user_gender: yup.string().required("Wajib diisi"),
    user_birthday: yup
      .date()
      .typeError("Wajib diisi")
      .required("Wajib Diisi")
      .test("birthday", "Minimal 17 tahun", (value) => {
        const currentDate = new Date()
        const selectedDate = new Date(value as Date)
        const age = currentDate.getFullYear() - selectedDate.getFullYear()
        return age >= 17
      }),
    user_interested_courses: yup
      .array()
      .min(1, "*Pilih minimal satu")
      .required("Pilih minimal satu bidang"),
    user_job_status: yup
      .string()
      .oneOf(["STUDENT", "EMPLOYED", "UNEMPLOYED"], "Wajib Dipilih")
      .required("Wajib Dipilih"),
    user_university: yup.string().when("user_job_status", {
      is: "STUDENT",
      then: (schema) =>
        schema
          .min(2, "Minimal 2 karakter")
          .max(50, "Maksimal 50 karakter")
          .required("Wajib Diisi")
          .trim()
          .matches(/(^[a-zA-Z]+[a-zA-Z0-9 ,./]*$)/, "Format yang kamu masukkan salah")
          .required("Nama universitas wajib diisi"),

      otherwise: (schema) => schema,
    }),
    user_faculty: yup.string().when("user_job_status", {
      is: "STUDENT",
      then: (schema) =>
        schema
          .min(2, "Minimal 2 karakter")
          .max(50, "Maksimal 50 karakter")
          .required("Wajib diisi")
          .matches(/(^[a-zA-Z]+[a-zA-Z0-9 ,./]*$)/, "Format yang kamu masukkan salah"),
      otherwise: (schema) => schema,
    }),
    user_majors: yup.string().when("user_job_status", {
      is: "STUDENT",
      then: (schema) =>
        schema
          .min(2, "Minimal 2 karakter")
          .max(50, "Maksimal 50 karakter")
          .required("Wajib diisi")
          .matches(/(^[a-zA-Z]+[a-zA-Z0-9 ,./]*$)/, "Format yang kamu masukkan salah"),
      otherwise: (schema) => schema,
    }),
    user_job: yup.string().when("user_job_status", {
      is: "EMPLOYED",
      then: (schema) =>
        schema
          .min(2, "Minimal 2 karakter")
          .max(50, "Maksimal 50 karakter")
          .required("Wajib diisi")
          .trim()
          .matches(/(^[a-zA-Z]+[a-zA-Z0-9 ,./]*$)/, "Format yang kamu masukkan salah"),
      otherwise: (schema) => schema,
    }),
    user_desired_job: yup
      .string()
      .min(2, "Minimal 2 karakter")
      .max(50, "Maksimal 50 karakter")
      .required("Wajib diisi")
      .trim()
      .matches(/(^[a-zA-Z]+[a-zA-Z0-9 ,./]*$)/, "Format yang kamu masukkan salah"),
    user_desired_job_sector: yup
      .string()
      .min(2, "Minimal 2 karakter")
      .max(50, "Maksimal 50 karakter")
      .required("Wajib diisi")
      .trim()
      .matches(/(^[a-zA-Z]+[a-zA-Z0-9 ,./]*$)/, "Format yang kamu masukkan salah"),
    user_linkedin_url: yup
      .string()
      .required("URL wajib diisi")
      .matches(/www.linkedin.com\/[a-zA-Z0-9]/gm, "Format yang kamu masukan salah"),
    info_from: yup
      .array()
      .of(yup.string())
      .when("is_other_selected", {
        is: false,
        then: (schema) => schema.min(1, "Minimal pilih 1").required("Wajib Dipilih"),
        otherwise: (schema) => schema,
      }),
    is_other_selected: yup.boolean(),
    other_info: yup.string().when("is_other_selected", {
      is: true,
      then: (schema) =>
        schema
          .required("Wajib Diisi")
          .min(2, "Minimal 2 karakter")
          .max(20, "Maksimal 20 Karakter")
          .trim(),
      otherwise: (schema) => schema,
    }),
    identity_card: yup.string().required("Wajib Dipilih"),
    cv: yup.string(),
    ijazah: yup.string(),
  })
  .required()

export const loginValidationSchema = yup
  .object()
  .shape({
    email: yup.string().email("Email tidak valid").required("Wajib diisi"),
    password: yup.string().required("Wajib diisi"),
  })
  .required()

export const resetValidationSchema = yup.object().shape({
  new_password: yup
    .string()
    .required("Password harus diisi")
    .min(8, "Password minimal 8 karakter")
    .matches(/(?=.*[0-9])(?=.*[a-z])/, "Password harus terdiri dari huruf dan angka"),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref("new_password")], "Password harus cocok")
    .required("Password harus diisi"),
})
